import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from 'app/modules/core.module';

@Component({
  selector: 'dashboard-detail-modal',
  templateUrl: './dashboard-detail-modal.html',
  standalone: true,
  imports: [CoreModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardDetailModalComponent {
  @Input() data: any = null
  @Input() detailType: string = ''
  @Input() detailTitle: string = ''
  @Input() onExport: ((type: string) => void) | null = null

  constructor(public activeModal: NgbActiveModal) {}

  handleExport() {
    this.onExport?.(this.detailType)
  }
}
